<!-- 符合性声明 添加 sqm -->
<template>
  <ComponentConformityDeclarations :kindType="data.kindType" :getData="data.getData" v-if="data.getData.supplyCode" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading"></ComponentConformityDeclarations>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';
import { debounce } from 'lodash';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import ComponentConformityDeclarations from "../ComponentConformityDeclarations"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmAdd',
    getData:{},
    subLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }

  const submit = debounce((val) => {
    submitImpl(val)
  }, 1000);

  const submitImpl = (val) => {
    console.log(val)
    data.subLoading = true
    proxy.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
    proxy.$http({
      url:'/base/rohs/addConformityDeclarations',
      method:'post',
      data:{
        fixConfig:true,
        ...val,
        relateMtlNo : val.relateMtlNo?.join(','), // 处理 材料组成相同的关联专用号 的格式 
        supplyFactoryName:val.supplyFactoryName?.join(','),// 供货工厂  的格式 
        supplyFactoryCode:val.supplyFactoryCode?.join(','),// 供货工厂  的格式 
        supplyFactory:undefined,
        isrtEmpName:data.trueName,
        deleteStatus: "N",
      }
    }).then((res=>{
      if(res.data.code == '0' && res.data.msg == '成功' && res.data.data == '1'){
        proxy.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message:h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'),confirmButtonText:h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          console.log('返回')
          routerBack()
        }})
      }else if(res.data.data == '-1'){
        proxy.info(h_i18n('743bd1f425a1a76bd09185dc52d498a0'))
      }else if(res.data.data == '-2'){
        proxy.info(h_i18n('b2ba68a1bd6fe5433b6738ad78c7ea8f'))
      }else if(res.data.data == '-3'){
        proxy.info(h_i18n('5a398f2938133a73de82d832ecbb0194'))
      }else if(res.data.data == '-4'){
        proxy.info(h_i18n('8abe2e7fe9b9e9ae5ade84332bf56b14'))
      }else{
        proxy.info(h_i18n('eff16848a8faf09eee11da1d718225c0')+res.data.data)
      }
    })).catch(err=>{
      proxy.warning(err)
    }).finally(()=>{
      proxy.closeLoading()
      data.subLoading = false
    })
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmAdd'
      data.conformityDeclarationsId = route.query.conformityDeclarationsId ?  route.query.conformityDeclarationsId : undefined
      data.sourceId = route.query.sourceId ?  route.query.sourceId : undefined
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })
</script>

<style>

</style>